import { IconChevronDown } from '@/icons';
import { Flex } from '@/ui/Flex/Flex';
import { T } from '@/ui/Text/Text';
import React, { useState } from 'react';
import { ChevronIcon } from './styles';

function FAQSection({
  faqs,
}: {
  faqs: { question: string; answer: string }[];
}) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <Flex direction="column" gap={16}>
      {faqs.map((item, index) => (
        <div
          key={item.question}
          onClick={() => toggle(index)}
          style={{
            display: 'grid',
            width: '100%',
            alignItems: 'center',
            gridTemplateColumns: '24px 1fr',
            cursor: 'pointer',
            gap: '4px',
          }}
        >
          <ChevronIcon $isOpen={openIndex === index}>
            <IconChevronDown />
          </ChevronIcon>
          <T body1>{item.question}</T>
          {openIndex === index && (
            <div
              style={{
                gridColumn: '2',
                width: '100%',
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
                whiteSpace: 'normal',
              }}
            >
              <T body2>{item.answer}</T>
            </div>
          )}
        </div>
      ))}
    </Flex>
  );
}

export default FAQSection;
